module.exports = __webpack_public_path__ + "img/starperformers-head-long@2x@2x.293e137d.png";